import { Services } from '../services'

export class Meeting {
    id!: string
    name!: string
    isActive!: boolean
    userIds: string[] = []
    whiteBoardContent!: string
    dayOfWeek!: DayOfWeek

    users!: any[]

    // private $deserialize(source: any, services: Services): void {
    //     this.users = services.data.users.items.filter(x => source.userIds.includes(x.id))
    //     source.users = this.users
    // }

    protected $setProperties(source: any, services: Services): void {
        this.users = services.data.users.items.filter(x => source.userIds.includes(x.id))
        source.users = this.users
    }
}
